module.exports = "module.exports = __webpack_public_path__ + \"static/media/img_7-1.ebab894d.png\";";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/content/figures/v2/img_7-1.png
// module id = 1434
// module chunks = 0